import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logos/Logo2.png";
import { useForm } from "react-hook-form";
import axios from "axios";
import toast from "react-hot-toast";
import { IoEye, IoEyeOff } from "react-icons/io5";
import forgotBg from "../../assets/img/nonAuth/forgotBg.webp";

const ForgotPassword = () => {
  let navigate = useNavigate();

  const [load, setLoad] = useState(false);
  const [passType, setPassType] = useState(true);
  const [confirmPassType, setConfirmPassType] = useState(true);
  const [email, setEmail] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState();
  const [newPassword, setNewPassword] = useState("");

  const getOtp = () => {
    setLoad(true);
    const data = {
      email: email,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/user/send-OTP`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of send OTP", response.data);
        toast.success(response.data.message);
        setLoad(false);
        setIsOtpSent(true);
      })
      .catch((error) => {
        console.log(error);
        setLoad(false);
        toast.error(error.message);
      });
  };

  const resetPassword = () => {
    const data = {
      email: email,
      otp: otp,
      newPassword: newPassword,
    };
    setLoad(true);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/user/reset-password`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of reset password : ", response.data);
        toast.success(response.data.message);
        setLoad(false);
        navigate("/admin/sign-in");
      })
      .catch((error) => {
        console.log(error);
        setLoad(false);
        toast.error(error.message);
      });
  };

  const d = new Date();
  let year = d.getFullYear();

  return (
    <React.Fragment>
      <section
        style={{
          backgroundImage: `url(${forgotBg})`,
        }}
        className="flex h-screen items-center justify-center bg-cover bg-center bg-no-repeat"
      >
        <div className="flex h-auto w-[90%] items-center justify-center rounded-xl bg-white px-6 py-4 sm:h-[100%] sm:w-[80%] md:h-auto md:w-2/3 lg:w-1/2 xl:w-1/3">
          <div className="h-auto w-full">
            <div className="mt-4 flex items-center justify-center">
              <img src={logo} alt="logo" className="h-10 w-auto" />
            </div>
            <h1 className="mb-2 mt-4 text-center text-2xl font-bold tracking-wide text-gray-800">
              Welcome Back!
            </h1>

            <p className="text-center text-sm tracking-wide text-gray-500">
              Enter Email to get OTP.
            </p>

            <form className="mt-4 space-y-4">
              {!isOtpSent ? (
                <div>
                  <label className="font-medium tracking-wide">Email</label>{" "}
                  <br />
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter Your Email"
                    className="mt-2 w-full rounded-lg border bg-[#f5f2f2] px-4 py-3 focus:border-primary focus:bg-white focus:outline-none"
                    autoFocus
                    autoComplete="email"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              ) : (
                <div>
                  <div>
                    <label className="font-medium tracking-wide">OTP</label>{" "}
                    <br />
                    <input
                      type="number"
                      name="otp"
                      id="otp"
                      placeholder="Enter OTP"
                      className="mt-2 w-full rounded-lg border bg-[#f5f2f2] px-4 py-3 focus:border-primary focus:bg-white focus:outline-none"
                      autoFocus
                      autoComplete="none"
                      required
                      onChange={(e) => setOtp(e.target.value)}
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .replace(/[^0-9]/g, "")
                          .slice(0, 6);
                      }}
                    />
                  </div>

                  <div className="relative mt-4">
                    <label className="font-medium tracking-wide">
                      Password
                    </label>{" "}
                    <br />
                    <input
                      type={!passType ? "text" : "password"}
                      name="password"
                      id="password"
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Enter Your Password"
                      className="mt-2 w-full rounded-lg border bg-[#f5f2f2] px-4 py-3 focus:border-primary focus:bg-white focus:outline-none"
                      required
                    />
                    {passType ? (
                      <IoEyeOff
                        onClick={() => setPassType(false)}
                        size="20"
                        className="absolute right-2 top-[2.8rem] cursor-pointer"
                      />
                    ) : (
                      <IoEye
                        onClick={() => setPassType(true)}
                        size="20"
                        className="absolute right-2 top-[2.8rem] cursor-pointer"
                      />
                    )}
                  </div>
                </div>
              )}

              <div className="my-4 text-right">
                <div
                  onClick={() => navigate("/auth/sign-in")}
                  className="cursor-pointer text-sm font-semibold tracking-wide hover:text-primary"
                >
                  Sign In
                </div>
              </div>

              <button
                type="button"
                className="flex w-full items-center justify-center rounded-lg bg-primary px-4 py-3 font-semibold tracking-wide text-white hover:bg-hoverPrimary"
                onClick={() => (!isOtpSent ? getOtp() : resetPassword())}
              >
                {load ? (
                  <div className="loaderButton"></div>
                ) : isOtpSent ? (
                  "Reset Password"
                ) : (
                  "Send OTP"
                )}
              </button>
            </form>

            <p className="mt-4 text-center text-sm tracking-wider text-gray-500">
              &copy; {year} CRM - All Rights Reserved.
            </p>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ForgotPassword;
